import { render, staticRenderFns } from "./SchoolMessage.vue?vue&type=template&id=d5fc2478"
import script from "./SchoolMessage.vue?vue&type=script&lang=js"
export * from "./SchoolMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports